export const Subscriber = {
  list: {
    url: "/subscriber",
    method: ["GET"]
  },
  detail: {
    url: "/subscriber/detail/{subscriberId}",
    method: ["GET"]
  },
  editionDetail: {
    url: "/subscriber/edition/detail/{editionId}",
    method: ["GET"]
  },
  paymentStatus: {
    url: "/subscriber/payment/status",
    method: ["GET"],
    required: ["subscriberId"]
  },
  paymentHistory: {
    url:"/subscriber/payment/history",
    method: ["GET"]
  },
  paymentHistoryBySubscriberId: {
    url:"/subscriber/payment/history/{subscriberId}",
    method: ["GET"]
  },
  creditCard: {
    url: "/subscriber/creditcard",
    method: ["GET"],
    required: ["subscriberId"]
  },
  renewal: {
    url: "/subscriber/renewal",
    method: ["GET"],
    required: ["subscriberId"]
  },
  cancelChangeOfPlan: {
    url: "/subscriber/renewal/changeplan/cancel",
    method: ["PUT"],
    required: ["subscriberId"]
  },
  create: {
    url: "/subscriber/create",
    method: ["POST"],
    required: [
      "email",
      "phone",
      "password",
      "passwordConfirmation",
      "firstName",
      "lastName",
      "encryptedInviterId",
      "captcha",
      "billingPostalCode",
      "billingPhone",
      "billingStreet",
      "billingStreetNumber",
      "billingStreetExtension",
      "billingStreetNeighborhood",
      "billingStateId",
      "billingCityId",
      "listPaymentMethod",
      "cpf",
      "couponName",
      "subscriptionTypeId",
      "shippingPostalCode",
      "shippingName",
      "shippingPhone",
      "shippingStreet",
      "shippingStreetNumber",
      "shippingStreetExtension",
      "shippingStreetNeighborhood",
      "shippingStateId",
      "state",
      "shippingStateCityId",
      "city",
      "subscriptionId",
      "compositionId",
      "utmSource",
      "utmCampaign",
      "utmMedium",
      "utmContent",
      "registrationUrl",
      "registrationMedium",
      "editionId",
      "startEditionName",
      "shippingPrice",
      "wants_to_be_in_mailing_list"
    ]
  },
  createWithVoucher: {
    url: "/subscriber/create/voucher",
    method: ["POST"],
    required: [
      // "email",
      // "phone",
      // "password",
      // "passwordConfirmation",
      // "firstName",
      // "lastName",
      // //"encryptedInviterId",
      // "captcha",
      // "billingPostalCode",
      // "billingPhone",
      // "billingStreet",
      // "billingStreetNumber",
      // //"billingStreetExtension",
      // "billingStreetNeighborhood",
      // "billingStateId",
      // "billingCityId",
      // "listPaymentMethod",
      // "cpf",
      // //"couponName",
      // "subscriptionTypeId",
      // "shippingPostalCode",
      // "shippingName",
      // "shippingPhone",
      // "shippingStreet",
      // "shippingStreetNumber",
      // //"shippingStreetExtension",
      // "shippingStreetNeighborhood",
      // "shippingStateId",
      // "state",
      // "shippingStateCityId",
      // "city",
      // "subscriptionId",
      // "compositionId",
      // "editionId",
      // "startEditionName",
      // "shippingPrice",
      // "wants_to_be_in_mailing_list"
    ]
  },
  changeCreditCard: {
    url: "/subscriber/creditcard/change",
    method: ["PUT"],
    required: [
      "creditCardName",
      "creditCardNumber",
      "creditCardCVV",
      "creditCardFlagId",
      "creditCardExpirationMonth",
      "creditCardExpirationYear",
      "subscriberId"
    ]
  },
  disableRecurrenceType: {
    url: "/subscriber/recurrence/disable/type",
    method: ["GET"],
    required: []
  },
  disableRecurrence: {
    url: "/subscriber/recurrence/disable",
    method: ["PUT"],
    required: [
      "subscriberId",
      "message",
      "username",
      "typeId"
    ]
  },
  enableRecurrence: {
    url: "/subscriber/recurrence/enable",
    method: ["PUT"],
    required: [
      "subscriberId"
    ]
  },
  attempt: {
    url: "/subscriber/attempt",
    method: ["POST"]
  },
  changePlan: {
    url: "/subscriber/renewal/changeplan",
    method: ["POST"]
  },
  addressChange: {
    url: "/subscriber/address/change",
    method: ["PUT"]
  },
  reactivateInfo: {
    url: "/subscriber/renewal/reactivateinfo",
    method: ["POST"]
  },
  personalUseCoupon: {
    url: "/subscriber/personalUseCoupon",
    method: ["GET"]
  }
};
